import { useTranslation } from "react-i18next";

import { ActionBanner } from "../../../common/components/functional/actionBanner/ActionBanner";
import { RoundedButton } from "../../../common/components/styled/styled";
import { Box } from "@mui/material";

type Props = {
  openCancelDialog: () => void;
  onSave: () => void;
  disableCancel: boolean;
  disableSave: boolean;
};

export const EditOrderActionBanner = ({
  openCancelDialog,
  onSave,
  disableCancel,
  disableSave,
}: Props) => {
  const { t } = useTranslation("order");
  return (
    <ActionBanner isOpen={true}>
      {!disableCancel ? (
        <RoundedButton
          variant="outlined"
          color="error"
          onClick={openCancelDialog}
        >
          {t("cancelOrder")}
        </RoundedButton>
      ) : (
        <Box></Box>
      )}

      <RoundedButton
        variant="contained"
        onClick={onSave}
        disabled={disableSave}
      >
        {t("saveOrder")}
      </RoundedButton>
    </ActionBanner>
  );
};
